/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	OrganisationCandidateProfileSettingsShowPathParams,
	OrganisationCandidateProfileSettingsShowResponse,
} from '../types/OrganisationCandidateProfileSettingsShow'

/**
 * GET /organisations/:organisation/candidate-profile-settings
 * @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationCandidateProfileSettingsController.php OrganisationCandidateProfileSettingsController::show
 */
export async function organisationCandidateProfileSettingsShow(
	organisation: OrganisationCandidateProfileSettingsShowPathParams['organisation'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganisationCandidateProfileSettingsShowResponse>> {
	return axiosInstance.get(`/organisations/${organisation}/candidate-profile-settings`, config)
}
